export default {
    props: {
        attributes: {
            type: Object
        },
        buttons: {
            type: Array
        },
        click: {
            type: Function
        },
        enable: {
            default: true,
            type: Boolean
        },
        group: {
            type: String
        },
        hidden: {
            type: Boolean
        },
        icon: {
            type: String
        },
        id: {
            type: String
        },
        imageUrl: {
            type: String
        },
        menuButtons: {
            type: Array
        },
        overflow: {
            type: String
        },
        overflowTemplate: {
            type: String | Function
        },
        primary: {
            type: Boolean
        },
        selected: {
            type: Boolean
        },
        showIcon: {
            type: String
        },
        showText: {
            type: String
        },
        spriteCssClass: {
            type: String
        },
        template: {
            type: String | Function
        },
        text: {
            type: String
        },
        togglable: {
            type: Boolean
        },
        toggle: {
            type: Function
        },
        type: {
            type: String
        },
        url: {
            type: String
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-buttons-vue-wrapper/src/KendoToolBar/Items.js